<template>
	<div ref="content"></div>
</template>

<script>
/* eslint-disable */
import componentLoader from './componentLoader';
export default {
	name: 'BlockLoader',
	components: {},
	props: {
		blockContent: {
			type: Array,
			default: function () {
				return [];
			},
		},
		articleId: String,
	},
	data() {
		return {
			mounted: false,
			renderedComponents: [],
			blocksUrl: null,
			renderTimestamp: 0,
		};
	},

	watch: {
		blockContent() {
			if (this.mounted) this.updateContent();
		},
	},

	methods: {
		updateContent() {
			this.clearPage();
			this.renderContent();
		},
		clearPage() {
			this.renderedComponents.forEach((child) => {
				if (child.$el.parentNode) child.$el.parentNode.removeChild(child.$el); // remove dom nodes of component
				child.$destroy(); // destroy component
			});
		},
		async renderContent() {
			this.renderTimestamp = Date.now();
			let timestamp = this.renderTimestamp;
			for (const block of this.blockContent) {
				const BlockComponent = await componentLoader.get(block.name);
				if (timestamp !== this.renderTimestamp) return; // if renderTimestamp changed while awaiting, cancel current rendering
				const component = new BlockComponent({
					propsData: { ...block, articleId: this.articleId },
					store: this.$store,
				}).$mount();
				if (block.modifier) {
					component.$el?.classList.add(block.modifier);
				} else {
					component.$el?.classList.add('standard');
				}
				this.renderedComponents.push(component);
				this.$el.appendChild(component.$el);
			}
		},
	},
	mounted() {
		this.mounted = true;
		this.updateContent();
	},
};
</script>

<style></style>
